// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v0_j-","col":"styles_col__1Ikug"};